var map = {
	"./10.png": "HhML",
	"./11.png": "l33d",
	"./12.png": "dYNG",
	"./3.png": "Y95s",
	"./4.png": "CNoh",
	"./5.png": "9IMC",
	"./6.png": "HZan",
	"./7.png": "gd3U",
	"./8.png": "c0er",
	"./9.png": "vmBi",
	"./lucky_cn.png": "pmPX",
	"./lucky_en.png": "6ngs",
	"./lucky_tw.png": "VZeV",
	"./path_bg.png": "YG/S"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "kDBn";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fqzs ^\.\/.*\.png$
// module id = kDBn
// module chunks = 0